import * as React from "react";
import PropTypes from "prop-types";
import Anchor from "../../HTMLEntities/Anchor";

class ReadMore extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            charLimit: props.charLimit,
        };
    }

    getReadMoreContent = () => {
        const {charLimit} = this.state;
        const {children, readMoreText} = this.props;
        if (children.length > charLimit) {
            return (
                <React.Fragment>
                    {children.substr(0, charLimit)}...
                    <Anchor onClickHandle={this.showLongText} linkLabel={readMoreText} />
                </React.Fragment>
            );
        } else {
            return <React.Fragment>{children}</React.Fragment>;
        }
    };

    showLongText = () => {
        const {children} = this.props;
        this.setState({charLimit: children.length});
        this.getReadMoreContent();
    };

    render() {
        return <React.Fragment>{this.getReadMoreContent()}</React.Fragment>;
    }
}
ReadMore.propTypes = {
    charLimit: PropTypes.number,
    readMoreText: PropTypes.string,
    children: PropTypes.string.isRequired,
};
ReadMore.defaultProps = {
    charLimit: 150,
    readMoreText: "Read more",
};
export default ReadMore;
